export default "__VITE_ASSET__CAJ8bEe0__"